import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const usePreviousProjets = () => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['previous-projects'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/projects/previous');
      return response.data;
    },
    throwOnError: errorMessage,
  });
  return query;
};

export const useProjet = projectId => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['project', projectId],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/projects/${projectId}`);
      return response.data;
    },
    enabled: !!projectId,
    throwOnError: errorMessage,
  });
  return query;
};

export const useProjetDealerCopy = projectId => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['project-dealer-copy', projectId],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/projects/${projectId}/dealer-copy`);
      return response.data;
    },
    enabled: !!projectId,
    throwOnError: errorMessage,
  });
  return query;
};

export const useProjectWalls = projectId => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['project-walls', projectId],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/projects/${projectId}/walls`);
      return response.data;
    },
    enabled: !!projectId,
    throwOnError: errorMessage,
  });
  return query;
};

export const useProjectToolings = projectId => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['project-toolings', projectId],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/projects/${projectId}/toolings`);
      return response.data;
    },
    enabled: !!projectId,
    throwOnError: errorMessage,
  });
  return query;
};

export const useCeiling = (projectId, id) => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['ceiling', id],
    queryFn: async () => {
      const response = await axios.get(HOST + `/api/dealer-portal/projects/${projectId}/ceilings${id}`);
      return response.data;
    },
    enabled: id !== 'create' && id !== undefined,
    throwOnError: errorMessage,
  });
  return query;
};
